module.exports = __webpack_public_path__ + "hat-blueprint-hazelnut-ice-cream.4893e06efd846e7aa805.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/hat-blueprint-hazelnut-ice-cream.svg
// module id = ../../../../../src/assets/img/hat-blueprint-hazelnut-ice-cream.svg
// module chunks = main